import React from "react";
import { Container, Row, Col, Image, Nav, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css"; // Import the CSS module

function Footer() {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

  return (
    <footer className={`${styles.bgSecondary} p-4`}>
      <Container fluid>
        <Row className="mx-5">
          <Col className={styles.marginAfterNav}>
            <Stack className={styles.stackCenter}>
              <Image
                src={`${baseImagePath}logo/logo_leicht.png`}
                rounded
                width={212}
                height={200}
              />
              <h2 className={styles.textWhite}>KaMikaze Travel</h2>
              <p className={styles.textWhite}>Reisen um zu Erleben.</p>
            </Stack>
          </Col>
          <Col className={styles.marginAfterNav}>
            <h4 className={styles.textWhite}>Unternehmen</h4>
            <Nav className="flex-column">
              <Nav.Link href="/travel" className={styles.textWhite}>
                Reisen
              </Nav.Link>
              <Nav.Link href="/about" className={styles.textWhite}>
                Über uns
              </Nav.Link>
              <Nav.Link
                href="/Pauschalreiserichtlinie_kamikaze.pdf"
                className={styles.textWhite}
                target="_blank"
                rel="noopener noreferrer"
              >
                Pauschalreiserichtlinie
              </Nav.Link>
            </Nav>
          </Col>
          <Col className={styles.marginAfterNav}>
            <h4 className={styles.textWhite}>Bergführer</h4>
            <Nav className="flex-column">
              <Nav.Link href="/mountainguide" className={styles.textWhite}>
                Über mich
              </Nav.Link>
              <Nav.Link href="/contact" className={styles.textWhite}>
                Kontakt
              </Nav.Link>
              <Nav.Link href="/agb-bgf" className={styles.textWhite}>
                AGB Bergführer
              </Nav.Link>
            </Nav>
          </Col>
          <Col className={styles.contactRoundShape}>
            <div className={styles.contactContent}>
              <h4 className={styles.textWhite}>Schreib uns!</h4>
              <p>
                <a
                  href="mailto:info@kamikaze-travel.at"
                  className={styles.textWhite}
                >
                  info@kamikaze-travel.at
                </a>
              </p>
              <p>
                <a href="tel:+4368181611886" className={styles.textWhite}>
                  +43 681 816 118 86
                </a>
              </p>
            </div>
          </Col>
        </Row>
        <hr className="my-4" />
        <div className={`${styles.sbFooterCopyright} mt-4`}>
          <p className={styles.textWhite}>
            &copy; {new Date().getFullYear()} KaMikaze Travel e.U. All rights
            reserved.
          </p>
        </div>
        <Row className="justify-content-center">
          <Col xs="auto">
            {" "}
            {/* Use auto width to center the column */}
            <div className={styles.footerLinks}>
              <Link to="/terms" className="mx-3">
                AGB
              </Link>
              <Link to="/dsgvo" className="mx-3">
                Datenschutzbestimmungen
              </Link>
              <Link to="/impressum" className="mx-3">
                Impressum
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
